/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { tokens } from '@neo4j-ndl/base';
import tinycolor from 'tinycolor2';

/**
 * Takes a color string and returns color string
 * that is readable on top of that background. Prioritizes pallete
 *  text colors and uses black or white as fallback.
 */
export const getTextColorFromBackground = (color: string): string => {
  return tinycolor
    .mostReadable(
      color,
      [
        tokens.theme.light.color.neutral.text.default,
        tokens.theme.light.color.neutral.text.inverse,
      ],
      {
        includeFallbackColors: true,
      },
    )
    .toString();
};

/**
 * Takes a color string and returns a color string
 * that is darker or lighter depending on the given color.
 */
export const getHoverColor = (color: string): string => {
  const hslColor = tinycolor(color).toHsl();
  if (hslColor.l < 0.5) {
    return tinycolor(color).lighten(10).toString();
  }
  return tinycolor(color).darken(10).toString();
};

/**
 * Returns the most readable color on the given background color
 *  as a string from a list of palette text colors
 */
export const getDisabledTextColor = (backgroundColor: string): string => {
  return tinycolor
    .mostReadable(backgroundColor, [
      tokens.theme.light.color.neutral.text.weakest,
      tokens.theme.light.color.neutral.text.weaker,
      tokens.theme.light.color.neutral.text.weak,
      tokens.theme.light.color.neutral.text.inverse,
    ])
    .toString();
};

/**
 * Takes a color string and returns a color string
 * that is darker or lighter depending on the given color.
 */
export const getDisabledColor = (color: string): string => {
  const hslColor = tinycolor(color).toHsl();
  if (hslColor.l < 0.5) {
    return tinycolor(color).lighten(15).toString();
  }
  return tinycolor(color).darken(15).toString();
};
